const initialState = {
    loading: false,
    modal: -1,
    valets: [],
    logs: [],
    total: 0,
    delStatus: undefined
}

const manageValetReducer = (state = initialState, action) => {
    switch (action.type) {
        case "ADD_VALET":
            return {
                ...state,
                loading: true,
                modal: 1
            }
        case "ADD_VALET_SUCCESS":
            state.valets.unshift(action.valet)
            return { ...state, loading: false, modal: 0 }
        case "ADD_VALET_FAILED":
            return {
                ...state,
                loading: false,
                modal: 1
            }
        case "GET_VALETS":
            return {
                ...state,
                valets: action.valets,
                total: action.total,
                logs: action.staff_logs
            }
        case "UPDATE_VALET_SUCCESS":
            let newState = {...state}
            newState.valets.splice(action.index, 1, action.valet);
            return {
                ...state,
                loading: false,
                modal: 0
            }
        case "DELETE_STAFF":
            return {
                ...state,
                delStatus: -1
            }
        case "DELETE_VALET_SUCCESS":
            let originState = {...state}
            originState.valets.splice(action.index, 1);
            return {
                ...state,
                delStatus: 1
            }
        case "DELETE_VALET_FAILED":
            return {
                ...state,
                delStatus: 0
            }
        default:
            return state
    }
}

export default manageValetReducer